import type { SVGProps } from 'react';
const SvgIconInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M8 7.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 7.5M8 6a.75.75 0 1 0 0-1.5A.75.75 0 0 0 8 6" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.942 16c-.408 0-.687 0-.933-.016A7.5 7.5 0 0 1 .016 8.99 15 15 0 0 1 0 8.058v-.116c0-.408 0-.687.016-.933A7.5 7.5 0 0 1 7.01.016C7.255 0 7.534 0 7.942 0h.116c.408 0 .687 0 .933.016a7.5 7.5 0 0 1 6.993 6.993c.016.246.016.524.016.933v.116c0 .408 0 .687-.016.933a7.5 7.5 0 0 1-6.993 6.993C8.745 16 8.467 16 8.058 16zm-6.43-8.892C1.5 7.304 1.5 7.536 1.5 8s0 .696.013.892a6 6 0 0 0 5.595 5.595c.196.013.428.013.892.013s.696 0 .892-.013a6 6 0 0 0 5.595-5.595c.013-.196.013-.428.013-.892s0-.696-.013-.892a6 6 0 0 0-5.595-5.595C8.696 1.5 8.464 1.5 8 1.5s-.696 0-.892.013a6 6 0 0 0-5.595 5.595"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconInfo;
